/**
 * @hidden
 */
export var MIDNIGHT_DATE = new Date(1980, 0, 1);
/**
 * @hidden
 */
export var MIN_DATE = new Date(1900, 0, 1);
/**
 * @hidden
 */
export var MAX_DATE = new Date(2099, 11, 31);
/**
 * @hidden
 */
export var MIN_TIME = new Date(1980, 0, 1);
/**
 * @hidden
 */
export var MAX_TIME = new Date(1980, 0, 1, 23, 59, 59);
